import { Bars } from "react-loader-spinner";

const Loader = () => {
  return (
    // <div className="spinner-overlay">
    <div className="absolute-center">
      <Bars height={30} width={30} color="#0086ed" visible={true} />
    </div>
  );
};

export default Loader;
